var React = require('react');

function DrivingCity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.642 21.485a.946.946 0 0 1-.171.015H8.293v19.42h3.703c.672 0 1.216.465 1.216 1.04 0 .574-.544 1.04-1.216 1.04h-9.78C1.544 43 1 42.534 1 41.96c0-.575.544-1.04 1.216-1.04h4.456V20.805c0-.383.363-.693.81-.693h11.989c.058 0 .115.005.17.015V.694c0-.383.363-.694.811-.694H43.96c.448 0 .81.31.81.694v22.193h4.864c.448 0 .81.31.81.694v17.338h63.341c.672 0 1.216.466 1.216 1.04 0 .575-.544 1.041-1.216 1.041h-63.44c-.137 0-.269-.02-.392-.056a.927.927 0 0 1-.319.056c-.447 0-.81-.31-.81-.694V24.274H30.99v18.032c0 .383-.363.694-.81.694-.449 0-.811-.31-.811-.694V23.581c0-.383.362-.694.81-.694h12.97v-21.5H21.263v33.984c0 .383-.363.694-.81.694-.449 0-.811-.311-.811-.694V21.485z","transform":"translate(-1)"}));
}

DrivingCity.defaultProps = {"width":"114","height":"43","viewBox":"0 0 114 43"};

module.exports = DrivingCity;

DrivingCity.default = DrivingCity;
